export default "__VITE_ASSET__DRM$7s$9__"